import React from 'react';

import { RenderTableContainerProps } from '@bringg-frontend/bringg-react-table';
import { useTranslation } from 'react-i18next';

import { ColumnLabelTableRecord } from '../columns-labels-table';

import styles from './column-labels-table-container.module.scss';

const ColumnLabelsTableContainer: React.FC<RenderTableContainerProps<ColumnLabelTableRecord>> = ({
	tableInstance,
	RenderRow
}) => {
	const { t } = useTranslation();

	return (
		<>
			<div className={styles.tableHeader}>
				{tableInstance.headerGroups[0].headers.map(column => (
					<div key={column.id} className={styles.tableHeaderCell}>
						{column.render('Header')}
					</div>
				))}
			</div>
			<div className="table-body">
				{tableInstance.rows.length ? (
					tableInstance.rows.map((row, index) => <RenderRow key={row.id} index={index} />)
				) : (
					<div className={styles.empty} data-test-id="column-labels-empty">
						{t('WEB_USER_INTERFACE.COLUMN_LABELS.NO_RESULTS')}
					</div>
				)}
			</div>
		</>
	);
};

export default ColumnLabelsTableContainer;
